import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). The legacy literal 'white'
// modal background maps to surfaceElevated ('#fff' — same pixel in light).
const makeStyles = colors =>
  StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: 'center',
      backgroundColor: colors.overlay,
    },
    modalView: {
      marginHorizontal: 7,
      maxHeight: '85%',
      backgroundColor: colors.surfaceElevated,
      borderRadius: 20,
      padding: 24,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 16,
    },
    marginBottom24: {
      marginBottom: 24,
    },
    marginHorizontal11: {
      marginHorizontal: 11,
    },
    flexRow: {
      flexDirection: 'row',
    },
    leftTitle: {
      flex: 1,
      marginRight: '4%',
    },
    rightTitle: {
      flex: 1,
    },
    rowContainer: {
      flexDirection: 'row',
      marginTop: 10,
    },
    itemName: {
      padding: 9,
      width: '48%',
      marginRight: '4%',
      backgroundColor: colors.backgroundMuted,
    },
    remainingDays: {
      padding: 9,
      width: '48%',
      backgroundColor: colors.backgroundMuted,
      alignItems: 'center',
    },
  });

export default makeStyles;
